import { Typography } from '@mui/material'
import React from 'react'
import { formatBytes } from 'utils/document.util'

const HEIGHT = '50rem'

export function base64ToFile(
  base64String?: string | null,
  fileName?: string | null,
  fileType?: string | null,
): File | null {
  if (!base64String || !fileName || !fileType) return null

  // Remover prefixo, se existir
  if (base64String.includes(',')) {
    base64String = base64String.split(',')[1]
  }

  // Corrigir padding da string base64
  base64String = base64String.padEnd(
    base64String.length + ((4 - (base64String.length % 4)) % 4),
    '=',
  )

  // Validar string base64
  try {
    atob(base64String) // Verifica se a string é válida
  } catch (e) {
    console.error('String inválida em base64:', base64String, e)
    return null
  }

  // Decodificar a string base64 para um array de bytes
  const byteCharacters = atob(base64String)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024)
    const byteNumbers = new Array(slice.length)

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  // Criar um blob a partir dos bytes
  const blob = new Blob(byteArrays, { type: fileType })

  // Criar um arquivo a partir do blob
  return new File([blob], fileName, { type: fileType })
}

// Função para mapear a extensão para o tipo MIME adequado
export function getMimeType(ext: string) {
  switch (ext.toLowerCase()) {
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg'
    case 'png':
      return 'image/png'
    case 'gif':
      return 'image/gif'
    case 'pdf':
      return 'application/pdf'
    case 'txt':
      return 'text/plain'
    case 'csv':
      return 'text/csv'
    default:
      return 'application/octet-stream'
  }
}

export function renderFileContent(
  nomeArquivo?: string | null,
  arquivo?: string | null,
  tipoArquivo?: string | null,
) {
  if (!arquivo || !tipoArquivo || !nomeArquivo) {
    return <Typography>Arquivo não encontrado.</Typography>
  }

  // Monta a URL base64 do arquivo com o tipo MIME correto
  const extensao = nomeArquivo.split('.')[1]
  const mimeType = getMimeType(extensao)
  const fileSrc = `data:${mimeType};base64,${arquivo}`

  // Renderiza imagens (.jpg, .jpeg, .png, .gif)
  if (mimeType.startsWith('image/')) {
    return <img src={fileSrc} alt={nomeArquivo} style={{ maxWidth: '100%', maxHeight: HEIGHT }} />
  }

  // Renderiza PDFs (.pdf)
  if (mimeType === 'application/pdf') {
    return (
      <iframe
        src={fileSrc}
        title='Visualizar PDF'
        style={{ width: '100%', height: HEIGHT, border: 'none' }}
      />
    )
  }

  // Renderiza arquivos de texto (.txt, .csv)
  if (mimeType.startsWith('text/')) {
    return (
      <textarea
        value={atob(arquivo)}
        readOnly
        style={{ width: '100%', height: '500px', resize: 'none', border: '1px solid #ddd' }}
      />
    )
  }

  // Caso o tipo de arquivo não seja suportado
  return <Typography>Não é possível visualizar este tipo de arquivo.</Typography>
}

export function obterTipoArquivo(base64String: string) {
  if (!base64String) return ''
  return base64String.substring('data:'.length, base64String.indexOf(';base64'))
}

export function obterTamanhoArquivo(base64String?: string | null) {
  if (!base64String) return ''
  const byteString = atob(base64String)
  return formatBytes(byteString.length)
}
